module.exports = __webpack_public_path__ + "static/media/trash.84779886.svg";